// extracted by mini-css-extract-plugin
module.exports = {"header":"BurgerMenu_header__91iSP","title":"BurgerMenu_title__LTrg6"};